/* eslint-disable spellcheck/spell-checker */
// const XlsxParser = require('../lib/xlsParser/')
// const OdooParseClass = require('./odoo/parser.js')
/* eslint-disable camelcase */

const odoo = require('./odoo/parser.js')
const sage = require('./sage/parser.js')
const sage_i7 = require('./sage-i7/parser.js')
const sage_30 = require('./sage-30/parser.js')
const sage_coala = require('./sage-coala/parser.js')
const odoocommunity = require('./odoo_community/parser.js')

module.exports = {
  /**
   * @param {object} params
   * @param {function} callback
   */
  excelToJson: (params, callback) => {
    switch (params.softwareName) {
      case 'ODOO':
        odoo(params, callback)
        // XlsxParser(params, callback, OdooParseClass)
        break
      case 'ODOO-COMMUNITY':
        odoocommunity(params, callback)
        break
      case 'SAGE':
        sage(params, callback)
        break
      case 'SAGE-i7':
        sage_i7(params, callback)
        break
      case 'SAGE-30':
        sage_30(params, callback)
        break
      case 'SAGE-COALA':
        sage_coala(params, callback)
        break
      case 'AUTRE':
        sage(params, callback)
        break
    }
  }
}
